import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.nvaTeal,
  borderColor: colors.white
};
export default jumplink;